const MODALITIES_COLORS = {
    'in-person': '#B4FFBAB2',
    'online': '#FFE4CC',
    'hybrid': '#A9D8F5'
};
const MODALITIES_TEXT_COLORS = {
    'in-person': '#00B383',
    'online': '#7A3A00',
    'hybrid': '#1B65A0'
};
export const MODALITIES = [
    {
        name: 'Presencial',
        value: 'in-person',
        description: 'Participación en el predio de Punta Tech Meetup.',
        icon: 'map-pin',
        color: MODALITIES_COLORS['in-person'],
        textColor: MODALITIES_TEXT_COLORS['in-person']
    },
    {
        name: 'Online',
        value: 'online',
        description: 'Cobertura/streaming del evento.',
        icon: 'laptop',
        color: MODALITIES_COLORS['online'],
        textColor: MODALITIES_TEXT_COLORS['online']
    },
    {
        name: 'Híbrido',
        value: 'hybrid',
        description: 'Parte presencial y parte online.',
        icon: 'globe',
        color: MODALITIES_COLORS['hybrid'],
        textColor: MODALITIES_TEXT_COLORS['hybrid']
    }
];
